import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'booking_cancellation_confirmation';
export const route = 'booking_cancellation/confirmation/[[...primeFreeCancellationParams]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../../components/ConfirmationPage')));